import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from './Item'

export function FlightInfo() {
  const data = useCMSPageField('PDP.PracticalInformation')
  const flightInformation = data?.flightInformation
  const intl = useIntl()

  if (!flightInformation) {
    return null
  }

  return (
    <Item elementDL="Flight info" title={intl.formatMessage({ id: 'practical_info_flight_information_title' })} Glyph="AirplaneTakingOff">
      <RichText innerHTML={flightInformation} />
    </Item>
  )
}
